import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Table} from 'antd';
import { TableCard, } from 'components';
import { includes, number as lNumber } from 'libs';
import store from './store';
import { Action } from 'components';
import moment from "moment";

export default observer(function () {
  const [rowrecords, setrowRecords] = useState({});
  const [isdisabled, setDisabled] = useState(true)
  const [data, setData] = useState([])
 
  useEffect(()=>{
    setData(store.records)
  },[store.records])

  const columns = [ {
    title: 'PO号',
    width: '120px',
    dataIndex: 'purchaseNo',
  },{
    title: '订单行类型',
    // align: 'center',
    width: '80px',
    dataIndex: 'catalogName',
  },{
    title: '申请人',
    width: '80px',
    dataIndex: 'applyUserName',
  },{
    title: '项目号',
    width: '120px',
    dataIndex: 'projectNo',
  },{
    title: '发票抬头',
    width:200,
    ellipsis:true,
    dataIndex: 'invoiceTitle',
  }, {
    title: '产品名称',
    width: '150px',
    ellipsis:true,
    dataIndex: 'goodsName',
  }, {
    title: '品牌',
    width: '150px',
    ellipsis:true,
    dataIndex: 'brandName',
  }, {
    title: '货号',
    width: '120px',
    ellipsis:true,
    dataIndex: 'factoryCode',
  }, {
    title: '数量',
    width: '60px',
    dataIndex: 'number',
  }, {
    title: '税率',
    width: '80px',
    dataIndex: 'taxRate',
    render:(val)=>{
      if (val||val===0) {
        return `${val}%`
      }
      return null;
    }
  }, {
    title: '未税单价',
    width: '100px',
    dataIndex: 'priceWithoutTax',
  },  {
    title: '未税总价',
    width:100,
    dataIndex: 'totalPriceWithoutTax',
  }, {
    title: '含税单价',
    width: '100px',
    dataIndex: 'price',
  }, {
    title: '含税总价',
    width: '100px',
    dataIndex: 'totalPrice',
  }, {
    title: '出库状态',
    width: '100px',
    dataIndex: 'outStatus',
  }, {
    title: '物流详情',
    width: '100px',
    dataIndex: 'express',
    render: (val,info) =>
    <Action>
        <Action.Button type='link' style={{ fontSize: '0.0625rem' }} onClick={() => store.showWmsForm(info)}>详情</Action.Button>
    </Action>
  },{
    title: '操作',
    width: '100px',
    fixed: 'right',
    render: info => (
      <Action>
        <Action.Button style={{ fontSize: '0.0625rem' }} onClick={() => store.showForm(info)}>查看详情</Action.Button>
      </Action>
    )
  },]

  return (
    <Table
      rowKey="id"
      loading={store.fetching}
      dataSource={data}
      bordered
      columns={columns}
      scroll={{ x: 100,}}
      pagination={{
        showSizeChanger: true,
        showLessItems: true,
        current: store.page,
        pageSize: store.pageSize,
        total: store.pageTotal,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: store.pageChange
      }}
      onReload={store.fetchRecords}
    />
  )

})
